// Firebase Configuration and Initialization
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration from environment variables
// Firebase configuration with environment variables and hardcoded fallbacks
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAzUL6db7si2wkU9E30QPn4weBwy1a54Ko",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "bible-app-365f7.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "bible-app-365f7",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "bible-app-365f7.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "285399357092",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:285399357092:web:9021636d91c97309483831",
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-5M98RG13NP",
};

// Validate configuration
const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'];
const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);

if (missingKeys.length > 0) {
    console.error('❌ Missing Firebase configuration keys:', missingKeys);
    console.error('Please check your .env file and ensure all VITE_FIREBASE_* variables are set.');
    throw new Error(`Missing Firebase configuration: ${missingKeys.join(', ')}`);
}

// Initialize Firebase
let app;
let auth;
let db;
let storage;
let analytics;

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);

    // Initialize analytics only in production
    if (import.meta.env.PROD && firebaseConfig.measurementId) {
        analytics = getAnalytics(app);
    }

    console.log('✅ Firebase initialized successfully');
    console.log('📦 Project ID:', firebaseConfig.projectId);
} catch (error) {
    console.error('❌ Failed to initialize Firebase:', error);
    throw error;
}

export { app, auth, db, storage, analytics };
